export const environment = {
    entityRootUrl: 'https://api-entity.dev.epa.ohio.gov',
    clientID: 'f275e8fe-8233-412f-a4a3-5ba1a5bb3b3b',
    redirectURI: 'https://entity.dev.epa.ohio.gov/',
    swaggerUrl: 'https://api-entity.dev.epa.ohio.gov/swagger/swagger-ui/index.html',
};
